import { withInstall } from '../../utils/vue-utils'
import _Steps from './src/steps'

export const Steps = withInstall(_Steps)
export type StepsInstance = InstanceType<typeof _Steps>
export default Steps
